import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Navbar as BootstrapNavbar, Dropdown } from 'react-bootstrap';
import { GoBell } from 'react-icons/go';
import { HiMenu, HiOutlineColorSwatch } from 'react-icons/hi';
import { LuLogOut } from 'react-icons/lu';
import { RiUserSettingsLine } from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import { useLogout } from '../../Hooks/useLogout';
import {
  editNotification,
  getNotifications,
} from '../../Services/Admin/Notifications';
import {
  getAffiliateUnreadNotifications,
  getAffiliateUnreadCount,
  markAffiliateNotificationAsRead,
} from '../../Services/Affiliate/Notifications';
import Profile from '../../assets/images/lis.png';
import useUserStore from '../../Stores/UserStore';
import { calculateTimePassed, showErrorToast } from '../../Utils/Utils';
import CustomButton from '../CustomButton';
import CustomModal from '../CustomModal';
import TableActionDropDown from '../TableActionDropDown/TableActionDropDown';
import './navbar.css';

const Navbar = ({ sideBarToggle, sideBarClass }) => {
  let navigate = useNavigate();
  const { user, role } = useUserStore();
  // console.log(user, "sadhfkjasdnfsjdab fl")
  const logoutMutation = useLogout();
  const branch_name = user?.branch_name;
  const [logoutModal, setLogoutModal] = useState(false);
  const queryClient = useQueryClient();
  const [params, setParams] = useState({ unread_only: 1 });

  //GET ADMIN NOTIFICATIONS
  const { data: adminNotificationsData } = useQuery({
    queryKey: ['getNotifications', params],
    queryFn: () => getNotifications(params),
    refetchOnWindowFocus: false,
    retry: 1,
    enabled: role === 'admin',
  });

  //GET AFFILIATE UNREAD NOTIFICATIONS
  const { data: affiliateNotificationsData } = useQuery({
    queryKey: ['getAffiliateUnreadNotifications'],
    queryFn: () => getAffiliateUnreadNotifications(),
    refetchOnWindowFocus: false,
    retry: 1,
    enabled: role === 'affiliate',
  });

  //GET AFFILIATE UNREAD COUNT
  const { data: affiliateUnreadCountData } = useQuery({
    queryKey: ['getAffiliateUnreadCount'],
    queryFn: () => getAffiliateUnreadCount(),
    refetchOnWindowFocus: false,
    retry: 1,
    enabled: role === 'affiliate',
  });

  // Determine notification state based on role
  const notificationState = role === 'admin' 
    ? (adminNotificationsData?.notifications?.data ?? [])
    : (affiliateNotificationsData?.data ?? []);

  // Determine unread count based on role
  const unreadCount = role === 'admin'
    ? notificationState.length
    : (affiliateUnreadCountData?.data?.count ?? notificationState.length);

  // Admin notification mutation
  const editNotificationMutation = useMutation({
    mutationFn: (id) => editNotification(id),
    onSuccess: () => {
      queryClient.invalidateQueries('PackageDetails');
      queryClient.invalidateQueries(['getNotifications']);
    },
    onError: (error) => {
      console.error('Error updating notification', error);
      showErrorToast(error);
    },
  });

  // Affiliate notification mutation
  const markAffiliateAsReadMutation = useMutation({
    mutationFn: (uuid) => markAffiliateNotificationAsRead(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries(['getAffiliateUnreadNotifications']);
      queryClient.invalidateQueries(['getAffiliateUnreadCount']);
    },
    onError: (error) => {
      console.error('Error updating notification', error);
      showErrorToast(error);
    },
  });

  const getInitials = (name = '') => {
    return name
      ?.split(' ')
      ?.map((word) => word?.[0]?.toUpperCase())
      ?.join('');
  };
  const handleLogoutClick = () => {
    setLogoutModal(true);
  };

  const logoutAdmin = () => {
    logoutMutation.mutate(role);
  };

  const markAsRead = (notification) => {
    if (role === 'admin') {
      editNotificationMutation.mutate(notification.id);
    } else {
      const uuid = notification.uuid || notification.id;
      markAffiliateAsReadMutation.mutate(uuid);
    }
  };

  return (
    <>
      <BootstrapNavbar className={`customHeader ${sideBarClass}`} expand="md">
        <div className="d-flex gap-2 gap-sm-3">
          <div
            className={`toggleSidebarButton beechMein ${sideBarClass}`}
            onClick={sideBarToggle}
          >
            <HiMenu size={26} />
          </div>
          <h4 className="screen-title-body header-branch-name mb-0">
            {branch_name}
          </h4>
        </div>

        <div className="d-flex gap-2 gap-sm-3">
          {/* {role !== 'admin' || role !== 'affiliate' && (
            <CustomButton onClick={() => navigate('support')}>
              Support
            </CustomButton>
          )} */}

          <Dropdown className="notiDropdown d-flex ">
            <Dropdown.Toggle
              variant="transparent"
              className="position-relative notButton  p-0"
            >
              <GoBell className="notification-bell-icon" size={28} />
              {unreadCount > 0 && (
                <span className="badge">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </Dropdown.Toggle>
            <Dropdown.Menu className={`notiMenu`} align="end">
              <div className="notificationsBody">
                <div className="notificationsBodyHeader py-2">
                  <p className="mb-0 fw-medium">Notifications</p>
                  {unreadCount > 0 && (
                    <div className="newNotificationCount">
                      <p>{unreadCount} new</p>
                    </div>
                  )}
                </div>
                <hr className="my-0" />
                {notificationState.length === 0 ? (
                  <div className="text-center py-3">
                    <p className="text-muted mb-0">No new notifications</p>
                  </div>
                ) : (
                  notificationState?.map((notification, index) => (
                    <div
                      className={`singleNoti gap-2 ${
                        notification.read_at ? 'read' : 'unread'
                      }`}
                      key={notification.uuid || notification.id}
                    >
                      <div className="notificationBell">
                        <GoBell size={18} />
                      </div>
                      <div className="singleNotiContent flex-grow-1 d-flex flex-column justify-content-between gap-2">
                        <p className="notiTitle">
                          {notification.data?.body || notification.body || notification.message}
                        </p>
                        <div className="d-flex align-items-end justify-content-between">
                          <div className="d-flex flex-wrap gap-0 gap-sm-2">
                            <p className="notiDateTime d-flex gap-2">
                              {calculateTimePassed(notification.created_at)}
                            </p>
                          </div>
                          {!notification.read_at && (
                            <button
                              className={`notification-btn flex-shrink-0${
                                notification.read ? 'read-btn' : ' unread-btn'
                              }`}
                              onClick={() => markAsRead(notification)}
                              disabled={
                                editNotificationMutation.isPending ||
                                markAffiliateAsReadMutation.isPending
                              }
                            >
                              Mark As Read
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="notiFooter">
                <Dropdown.Toggle
                  variant="transparent"
                  className="notButton notifi-btn p-0"
                >
                  <Link to={role === 'admin' ? '/admin/notifications' : '/affiliate/notifications'}>View All</Link>
                </Dropdown.Toggle>
              </div>
            </Dropdown.Menu>
          </Dropdown>

          {/* <CustomButton onClick={() => toggleTheme()}>
            Toggle Theme
          </CustomButton> */}
          <TableActionDropDown
            actions={[
              {
                name: 'My Profile',
                icon: RiUserSettingsLine,
                onClick: () => {
                  if (user?.role === 'admin') {
                    navigate('/admin/profile');
                  } else {
                    navigate(role === 'admin' ? '/admin/profile' : '/affiliate/profile');
                  }
                },
              },
              {
                name: 'Logout',
                icon: LuLogOut,
                onClick: handleLogoutClick,
              },
            ]}
          >
            <div className="userImage beechMein">
              {/* {Profile?.image ? <img src={Profile?.image} className='user-profile-pic' /> : <h6>{getInitials(user?.full_name)}</h6>} */}
              <img src={Profile} alt="" />
            </div>
          </TableActionDropDown>
        </div>
      </BootstrapNavbar>
      <CustomModal
        show={logoutModal}
        close={() => {
          setLogoutModal(false);
        }}
        disableClick={logoutMutation.isPending}
        action={logoutAdmin}
        title="Logout?"
        description="Are you sure you want to logout?"
      />
    </>
  );
};

export default Navbar;
